import {AppState} from "../../index";
import {createSelector} from "@ngrx/store";
import * as fromAuthUser from "./auth-user.reducer"
import { InstitutionAuthUser } from "./auth-user.model";

export const currentState = (state: AppState) => state[fromAuthUser.authUsersFeatureKey];

export const selectAllAuthUsers = createSelector(currentState, fromAuthUser.selectAll);

export const selectAuthUser = createSelector(selectAllAuthUsers, (authUsers: InstitutionAuthUser[]) => {
    return authUsers?.[0];
});
